import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["period", "from", "to", "form", "panel"]

  connect() {
    if (this.hasPeriodTarget) {
      const matching = [...this.periodTarget.options].find(option =>
        option.dataset.from === this.fromTarget.value && option.dataset.to === this.toTarget.value)
      this.periodTarget.value = matching?.value || "custom"
    }
    this.revealInvalid = event => {
      const details = event.target.closest("details")
      if (details) details.open = true
      if (!this.panelTarget.classList.contains("show")) {
        event.preventDefault()
        this.showFilters(event.target, true)
      }
    }
    this.formTarget.addEventListener("invalid", this.revealInvalid, true)
  }

  disconnect() {
    this.formTarget.removeEventListener("invalid", this.revealInvalid, true)
  }

  changePeriod() {
    const option = this.periodTarget.selectedOptions[0]
    if (!option.dataset.from) {
      this.showFilters(this.fromTarget)
      return
    }
    this.fromTarget.value = option.dataset.from
    this.toTarget.value = option.dataset.to
    this.showFilters()
  }

  customPeriod() {
    if (this.hasPeriodTarget) this.periodTarget.value = "custom"
  }

  showFilters(focusField = null, validate = false) {
    const focus = () => {
      focusField?.focus()
      if (validate) focusField.reportValidity()
    }
    if (this.panelTarget.classList.contains("show")) {
      focus()
      return
    }
    if (focusField) this.panelTarget.addEventListener("shown.bs.collapse", focus, { once: true })
    window.bootstrap.Collapse.getOrCreateInstance(this.panelTarget, { toggle: false }).show()
  }
}
